<template>
    <div
        @click="goToBeatTape"
        class="row-service-container hover:tw-bg-infinity-row-hover-background tw-transition tw-flex sm:tw-grid sm:tw-gap-2 tw-rounded tw-grid-flow-col tw-items-center tw-p-2 tw-border-infinity-background-emphasized tw-border-0 tw-border-b tw-border-solid tw-group tw-cursor-pointer">

        <!-- Artwork -->
        <div class="tw-w-13 tw-h-13 tw-flex-shrink-0 tw-mr-2 sm:tw-mr-0">
            <Artwork class="tw-rounded tw-overflow-hidden"
                     :src="beatTape.image(imageSize)"
                     :image-size="imageSize">
            </Artwork>
        </div>

        <!-- Title & Tracks -->
        <div class="tw-truncate tw-mr-2 sm:tw-mr-0" style="padding: 0 !important;">

            <!-- Title -->
            <router-link
                class="tw-truncate tw-transition tw-font-bold group-hover:tw-text-infinity-row-hover-primary-text hover:tw-underline group-hover:tw-text-infinity-row-hover-primary-text"
                @click.native.stop
                :to="{name: 'beat-tape', params: {pageId: pageId, beatTape: beatTape.id}}">{{ beatTape.title }}
            </router-link>

            <div class="tw-flex tw-space-x-3">
                <div
                    v-for="item in [{
                        icon: 'waveform-path',
                        label: ( beatTape.itemsCount !== undefined ? beatTape.itemsCount : 0 )  + ' Beats'
                    }
                    ]"
                    class="tw-transition tw-flex tw-items-center group-hover:tw-text-infinity-row-hover-secondary-text tw-text-infinity-tertiary-text tw-text-xxs tw-font-light">
                    <font-awesome-icon :icon="item.icon" class="tw-mr-1" />
                    {{ item.label }}
                </div>
            </div>
        </div>

        <!-- Buttons -->
        <div class="tw-justify-self-end tw-ml-auto sm:tw-ml-3 tw-grid tw-items-center tw-grid-flow-col tw-gap-3">
            <ShareButton class="tw-text-infinity-secondary-text" :parent="this.parent" :item="beatTape"></ShareButton>
            <BuyButton :item="beatTape"></BuyButton>
        </div>
    </div>
</template>

<script>
import ShareButton from "../../sharebutton.vue";
import BuyButton from "../../shared/buy-button.vue";
import Artwork from "../../base/base-artwork";
import PlayButton from "../../base/base-play";
import Chip from "../../base/base-item-row-chip";
import Tags from "../../base/base-item-row-tag";

export default {
    props: {
        parent: {
            type: Object,
            default: null
        },
        beatTape: {
            type: Object,
            required: true
        },
        showPrice: {
            type: Boolean,
            default: false
        },
        imageSize: {
            type: [Number, String],
            default: 100
        },
    },
    components: {
        Chip,
        Tags,
        PlayButton,
        Artwork,
        ShareButton,
        BuyButton
    },
    computed: {
        pageId() {
            return this.$store.state.currentPage.id
        }
    },
    methods: {
        goToBeatTape() {
            const params = {pageId: this.pageId, beatTape: this.beatTape.id}
            this.$router.push({name: 'beat-tape', params: params})
        }
    }

};
</script>
<style lang="scss" scoped>
.row-service-container {
    grid-template-columns: auto 1fr 1fr;

    &:last-of-type {
        border-bottom: none;
    }
}
</style>
